<template>
  <div class="col left-navbar-container d-none d-sm-block">
    <div class="left-navbar pt-5">
      <ul>
        <li id="test-tool-gui" class="active">
          <router-link :to="{ name: 'tests'}" class="icon-container">
            <i class="material-icons">settings</i>
            <p class="d-none d-sm-inline"> Test Tool GUI</p>
          </router-link>
        </li>
        <li id="logout">
          <router-link :to="{ name: 'logout'}" class="icon-container">
            <i class="material-icons">power_settings_new</i>
            <p class="d-none d-sm-inline"> Logout</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeftNav'
}
</script>

<style lang="scss" scoped>
.left-navbar-container {
  min-height: calc(100vh - 60px);
  padding: 0;
  max-width: 200px;
}

.left-navbar {
  position: fixed;
  width: 200px;
  background-color: rgb(65, 72, 81);
  color: rgb(255, 255, 255);
  height: calc(100vh - 60px);

  ul {
    padding: 0;

    &.push-bottom {
      position: absolute;
      bottom: 0;
    }

    li {
      list-style: none;

      &:hover {
        background-color: rgb(106, 111, 118);
      }

      a {
        color: #FFFFFF;
        padding: 30px;
        display: block;
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
        }
      }

      &.active {
        background-color: rgb(106, 111, 118);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LeftNav.vue